const jsUrl = 'https://cdn.jin10.com/assets/js/plugins/dsbridge.js';

function loadJs(url, callback) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  if (typeof callback !== 'undefined') {
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (
          script.readyState === 'loaded' ||
          script.readyState === 'complete'
        ) {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = function () {
        callback();
      };
    }
  }
  script.src = url;
  document.body.appendChild(script);
}

function myloadjs(url, callback) {
  loadJs(url, callback);
}

const _log = (txt) => {
  if (window.location.href.indexOf('local') > -1) {
    let $item = document.createElement('div');
    $item.innerHTML = txt;
    // document.querySelector('.vip-header').appendChild($item)
  }
};
const openUrl = (url) => {
  _log('openUrl');
  // loadBsBridgeResource(() => {
  if (
    window.dsBridge.hasNativeMethod('comm.isAndroid') &&
    window.dsBridge.hasNativeMethod('comm.openUrl')
  ) {
    window.dsBridge.call('comm.openUrl', url);
    // dispatchApp('uploadAppStatics')(options);
  } else if (
    window.dsBridge.hasNativeMethod('comm.isAndroid') &&
    window.dsBridge.hasNativeMethod('comm.openAppWebViewWithNav')
  ) {
    window.dsBridge.call('comm.openAppWebViewWithNav', url);
    // dispatchApp('uploadAppStatics')(options);
  }
  if (
    typeof window.webkit !== 'undefined' &&
    typeof window.webkit.messageHandlers !== 'undefined' &&
    window.webkit.messageHandlers.openUrl
  ) {
    _log('ios url');
    window.webkit.messageHandlers.openUrl.postMessage(url);
  } else if (
    typeof window.webkit !== 'undefined' &&
    typeof window.webkit.messageHandlers !== 'undefined' &&
    typeof window.webkit.messageHandlers.openAppWebView !== 'undefined'
  ) {
    _log('ios openAppWebView');
    window.webkit.messageHandlers.openAppWebView.postMessage(url);
  } else {
    window.open(url);
  }
  // })
};

let loadBsBridgeResource = (cb) => {
  if (typeof window.dsBridge === 'undefined') {
    myloadjs(jsUrl, () => {
      cb();
    });
  } else {
    cb();
  }
};
window._modifyAppShareUrl = (options) => {
  let name = 'modifyAppShareUrl';
  loadBsBridgeResource(() => {
    if (window.dsBridge.hasNativeMethod('comm.isAndroid')) {
      window.dsBridge.call(`comm.${name}`, options);
      _log(`android ${name}`);
    } else if (
      typeof window.webkit !== 'undefined' &&
      typeof window.webkit.messageHandlers !== 'undefined' &&
      window.webkit.messageHandlers[name]
    ) {
      window.webkit.messageHandlers[name].postMessage(options);
      _log(`ios ${name}`);
    }
  });
};
window._uploadAppStatics = (typedesc, referer, oTtype, exOptions) => {
  let cb = () => {
    if (!exOptions) {
      exOptions = {};
    }

    let ops = {
      click: '点击',
      view: '浏览',
      search: '搜索',
      change: '切换',
    };
    let enableUrl = exOptions.enableUrl;

    let options = {
      type: `${ops[oTtype || 'click']}${typedesc}`,
      referer: `${referer}`,
      source_type: 'tv',
      // url: exOptions.url || window.location.href,
      // op: o_type
    };
    if (enableUrl !== false) {
      options.url = exOptions.url || window.location.href;
    }

    window.console.log('用户行为:' + JSON.stringify(options));

    if (window.dsBridge.hasNativeMethod('comm.isAndroid')) {
      window.dsBridge.call('comm.uploadAppStatics', options);
      _log('androidos uploadAppStatics');
      // dispatchApp('uploadAppStatics')(options);
    } else if (
      typeof window.webkit !== 'undefined' &&
      typeof window.webkit.messageHandlers !== 'undefined' &&
      window.webkit.messageHandlers.uploadAppStatics
    ) {
      window.webkit.messageHandlers.uploadAppStatics.postMessage(options);
      _log('ios uploadAppStatics');
    }
  };

  if (typeof window.dsBridge === 'undefined') {
    myloadjs(jsUrl, () => {
      cb();
    });
  } else {
    cb();
  }
};

let __init__ = () => {
  let cb = () => {
    let $list = document.body.querySelectorAll('.is-vip .chat-topad');
    for (let i = 0; i < $list.length; i++) {
      let $item = $list[i];

      if ($item.getAttribute('is-init') !== '1') {
        $item.setAttribute('is-init', '1');
        let $close = $item.querySelector('.chat-topad_close');
        let $link = $item.querySelector('a');
        $close.addEventListener('click', () => {
          window._uploadAppStatics('广告图关闭', 'VIP直播');
        });
        $link.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          loadBsBridgeResource(() => {
            openUrl($link.getAttribute('href'));
            window._uploadAppStatics('直播广告', 'VIP直播');
          });
        });
        // console.log($item)
      }
    }
    let $topList = document.body.querySelectorAll(
      '.is-vip .chat-top-news .chat-list_item'
    );
    for (let i = 0; i < $topList.length; i++) {
      let $topItem = $topList[i];

      if ($topItem.getAttribute('is-init') !== '1') {
        $topItem.setAttribute('is-init', '1');
        let $close = $topItem.querySelector('.chat-tv_close');
        let $link = $topItem.querySelector('.chat-message_text');
        if ($close) {
          $close.addEventListener('click', () => {
            window._uploadAppStatics('直播置顶评论关闭', 'VIP直播');
          });
        }

        if ($link) {
          $link.addEventListener('click', () => {
            window._uploadAppStatics('直播置顶评论', 'VIP直播');
          });
        }

        // console.log($topItem)
      }
    }
  };
  setInterval(() => {
    cb();
  }, 1000);
  cb();
};
__init__();



// WEBPACK FOOTER //
// ./src/views/tv/statics.js